import { render, staticRenderFns } from "./whyMicro.vue?vue&type=template&id=77e9a3de"
import script from "./whyMicro.vue?vue&type=script&lang=js"
export * from "./whyMicro.vue?vue&type=script&lang=js"
import style0 from "./whyMicro.vue?vue&type=style&index=0&id=77e9a3de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports